import { FC, Fragment, useState } from 'react';

import EditAnomalyItemUTM from '../../../forms/custom-fvi/editAnomalyItemUTM';
import AnomalyItemUTM from '../../../forms/custom-fvi/anomalyItemUTM';
import AutTable from '../../../blocks/aut-grid-table';

import { getNewCustomFVITableColumns } from '../../../../utils/data';
import { NewAnomalyItem as Anomaly, CoverDataItem, DamageClassItem } from '../../../../utils/models';

interface Props {
	nextAnomalyID: number;
	damageClasses: DamageClassItem[];
	anomalyItems: Anomaly[];
	onDataChange: (items: Anomaly[]) => void;
	locationOptions: CoverDataItem[];
}

const UTMAnomalies: FC<Props> = (props) => {
	const [itemToEdit, setItemToEdit] = useState<Anomaly | null>(null);

	const getNewAnomalyID = () => {
		if (props.anomalyItems.length === 0) return props.nextAnomalyID;

		return props.anomalyItems[props.anomalyItems.length - 1].id + 1;
	};

	const handleAddItem = (item: Anomaly) => {
		const newAnomalyItems = [...props.anomalyItems];
		newAnomalyItems.push({ ...item, id: getNewAnomalyID() });

		props.onDataChange(newAnomalyItems);
	};

	const handleDeleteItem = (item: Anomaly): void => {
		const newAnomalyItems = props.anomalyItems.filter((i) => i.id !== item.id);
		props.onDataChange(newAnomalyItems);
	};

	const handleEditItem = (item: Anomaly): void => {
		props.onDataChange(props.anomalyItems.map((anomaly) => anomaly.id === item.id ? item : anomaly));
		setItemToEdit(null);
	};

	const handleCancelEdit = (): void => {
		setItemToEdit(null);
	};

	return (
		<Fragment>
			{itemToEdit ? (
				<EditAnomalyItemUTM
					anomalyItem={itemToEdit}
					onEdit={handleEditItem}
					onCancelEdit={handleCancelEdit}
					options={props.locationOptions}
				/>
			) : (
				<AnomalyItemUTM
					damageClasses={props.damageClasses} 
					onAdd={handleAddItem} 
					options={props.locationOptions}
				/>
			)}

			<div className="divider my-4"></div>

			<AutTable
				data={props.anomalyItems}
				tableColumns={getNewCustomFVITableColumns()}
				onDeleteItem={handleDeleteItem}
				onEditItem={(item: Anomaly) => setItemToEdit(item)}
			/>
		</Fragment>
	);
};

export default UTMAnomalies;
